import { envConfig } from "../../utils/constants";
import {
  CmsBlocksDataState,
  CmsPageItem,
} from "../../utils/interfaces/cmsBlock";
import { client } from "../graphql";
import { CMS_CONTENT_BLOCK, CMS_CONTENT_PAGE } from "./queries";

class CMSBlockServices {
  async fetchCMSBlocks(identifier: string): Promise<CmsBlocksDataState> {
    const res = await client.query({
      query: CMS_CONTENT_BLOCK,
      variables: { identifier },
      context: { headers: { store: envConfig.store } },
    });
    return res.data.cmsBlocks;
  }

  setCMSBlocks = async (
    identifier: string,
    action: (res: any) => void,
    callback: () => void
  ) => {
    await this.fetchCMSBlocks(identifier)
      .then((res: any) => {
        if (res) action(res);
        callback();
      })
      .catch((e: Error) => {
        callback();
      });
  };

  async fetchCMSPage(identifier: string): Promise<CmsPageItem> {
    const res = await client.query({
      query: CMS_CONTENT_PAGE,
      variables: { identifier },
      context: { headers: { store: envConfig.store } },
    });
    return res.data.cmsPage;
  }

  setCMSPages = async (
    identifier: string,
    action: (res: any) => void,
    callback: () => void
  ) => {
    await this.fetchCMSPage(identifier)
      .then((res: any) => {
        if (res) action(res);
        callback();
      })
      .catch((e: Error) => {
        callback();
      });
  };
}

const cmsBlockServicesInstance = new CMSBlockServices();
export default cmsBlockServicesInstance;
